/** @jsx jsx */
import { jsx, useThemeUI } from 'theme-ui'
import React from 'react'

import loadable from '@loadable/component'
import { List as SparkList } from '@uswitch/spark.list'
import ICONS from '@uswitch/ev-utils/icons'
import withComponentBase from '../helpers/with-component-base'
import { Type } from '@uswitch/spark.type'

const ListItem = loadable(() => import('./list-item'))

const ListItems = ({ items, variant }) => {
  const { theme } = useThemeUI()

  return (
    <For each='item' of={items} index='i'>
      <ListItem
        icon={variant && ICONS[variant] ? ICONS[variant].icon : null}
        iconColor={
          variant && ICONS[variant]
            ? ICONS[variant].color || theme.elements.list[variant].color
            : null
        }
        key={i}
      >
        {item}
      </ListItem>
    </For>
  )
}

const ChildrenWithProps = ({ children, listType, variant }) =>
  React.Children.map(children, (childComponent) =>
    React.cloneElement(childComponent, { listType, variant }),
  )

const List = ({ title, items = [], variant, children, listType = 'bullet' }) => {
  const Items = items.length ? ListItems : ChildrenWithProps

  return (
    <>
      {title && <Type.H2>{title}</Type.H2>}
      <SparkList sx={{ display: 'inline-block' }}>
        <Items items={items} variant={variant} listType={listType} children={children} />
      </SparkList>
    </>
  )
}

export default withComponentBase(List, {
  withHeaderFooter: true,
  headerStyles: { pb: 20, pt: 0 },
})
